import O1HD from "../../../../engines/gameEngine";
import spendGameManager from "../../manager/spendGameManager";
import PageHasInvestment from "./PageHasInvestment";

const {ccclass, property} = cc._decorator;

/**
 *  日报告 预制体
 */
@ccclass
export default class DayRecordPrefab extends cc.Component {

    @property({type:cc.PageView,displayName:""})
    pageView : cc.PageView = null;
    @property(cc.Node)
    pageHasInvestment : cc.Node = null;

    private mGameLayer : spendGameManager;

    complete:()=>void;

    onLoad () {}

    start () {
        this.pageView.setCurrentPageIndex( 0 );
    }

    bindData( gameLayer : spendGameManager ,complete?:()=>void){
        this.mGameLayer = gameLayer;
        this.complete = complete;
        this.pageHasInvestment.getComponent( PageHasInvestment ).bindData( this.mGameLayer , true );
    }

    onBtnChoosePage(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
    }

    changePage(){

    }

    /**
     * 返回
     */
    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.complete && this.complete();
        this.node.removeFromParent();
        this.node.destroy();
    }
}
